import { FC } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";

export type SuccessProps = {
  onGoHome: () => void;
};

export const Success: FC<SuccessProps> = ({ onGoHome }) => {
  return (
    <Box textAlign="center">
      <Stack spacing={2} alignItems="center">
        <CheckCircleOutline color="success" sx={{ fontSize: 64 }} />
        <Typography variant="h5">Success</Typography>
        <Typography variant="body2" color="text.secondary">
          Your onboarding is complete.
        </Typography>
        <Button variant="contained" onClick={onGoHome} sx={{ mt: 2 }}>
          Go to Home
        </Button>
      </Stack>
    </Box>
  );
};
